module.exports = __webpack_public_path__ + "img/customer_g_inactive.b169620c.svg";